import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSundryCreditorBalanceApi } from "../../../apiservice/accounts";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchSupplierDue = createAsyncThunk(
  "supplierDue/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const reqPayload = {
        supplierId: filters.supplierId || null,
        fromDate: filters.fromDate || undefined,
        toDate: filters.toDate || undefined,
      };

      const res = await getSundryCreditorBalanceApi(reqPayload);
      
      if (res.data && res.data.accounts) {
        return res.data.accounts;
      }
      
      return [];
    } catch (err) {
      console.error("Error fetching supplier due data:", err);
      
      if (err.response?.status === 401) {
        sessionStorage.clear();
        window.location.reload();
        return rejectWithValue("Authentication failed");
      }
      
      return rejectWithValue(
        err.response?.data?.message || 
        err.message || 
        "Failed to fetch supplier due data"
      );
    }
  }
);

const initialState = {
  list: [],
  loading: false,
  filters: {
    filterType: "All Supplier",
    supplierId: null,
    supplierName: "",
    fromDate: null,
    toDate: null,
  },
  totalBalance: 0,
};

const supplierDueSlice = createSlice({
  name: "supplierDue",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setTotalBalance: (state, action) => {
      state.totalBalance = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupplierDue.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSupplierDue.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
        state.totalBalance = action.payload.reduce((sum, curr) => sum + parseFloat(curr.balance || 0), 0);
      })
      .addCase(fetchSupplierDue.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters, setTotalBalance } = supplierDueSlice.actions;
export default supplierDueSlice.reducer;